import React from "react";

const MultipleBirth = ({ data, summary: isSummary }) => {
  if (isSummary) {
    if (typeof data === "boolean" && data === true) {
      return <div>Multiple Birth</div>;
    }
    return <div>Multiple Birth: {data}</div>;
  }
  return (
    <div>
      <h4>Multiple Birth</h4>
      <div> {typeof data === "boolean" ? "Yes" : `Order: ${data}`} </div>
    </div>
  );
};

export default MultipleBirth;
